module.exports = __webpack_public_path__ + "logo-padelikeskus.svg?fe30e4c5e955af720bfa3afe9afd7631";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-padelikeskus.svg
// module id = 169
// module chunks = 0